export default __webpack_public_path__ + "static/media/seriously.57e1108c.png";